export const PREBID_AD_WHITELIST = ['mrect', 'leaderc', 'spot', 'mmrect', 'mab', 'mspot'];

const PUBMATIC_CONFIG = {
  publisherId: '161958',
  profId: '7209',
};
const DEFAULT_PUBMATIC_AD_SLOT = '804007bc349e7c9e17432a3669945777';
const OPENX_DEL_DOMAIN = 'edmundsinc-d.openx.net';

const PREBID_INVENTORY_CONFIG = {
  'mobile.new.mdl': {
    pubmaticAdSlot: DEFAULT_PUBMATIC_AD_SLOT,
    sizes: {},
  },
  'wired.new.mdl': {
    pubmaticAdSlot: DEFAULT_PUBMATIC_AD_SLOT,
    sizes: {},
  },
  'mobile.carinventory': {
    pubmaticAdSlot: '8bf6e84d80a4e2985dcacf0a47be3f07',
    sizes: {
      '300x250': { appnexusPlacementId: '26638213', openxUnit: '557911768' },
      '320x50': { appnexusPlacementId: '26638215', openxUnit: '557911771' },
    },
  },
  'mobile.new.type': {
    pubmaticAdSlot: '13d99603c92b6ad9d8f7ca17b3ecae7c',
    sizes: {
      '300x250': { appnexusPlacementId: '26638237', openxUnit: '557911728' },
      '320x50': { appnexusPlacementId: '26638238', openxUnit: '557911730' },
    },
  },
  'mobile.used.mdl': {
    pubmaticAdSlot: 'c51b8ed37e5063d8c180851afcd1f40e',
    sizes: {
      '300x250': { appnexusPlacementId: '26638244', openxUnit: '557911741' },
      '320x50': { appnexusPlacementId: '26638245', openxUnit: '557911744' },
    },
  },
  'wired.carinventory': {
    pubmaticAdSlot: '16cbc95a5db05f16890bd98f363450bd',
    sizes: {
      '300x250': { appnexusPlacementId: '26638255', openxUnit: '557911745' },
    },
  },
  'wired.new.type': {
    pubmaticAdSlot: 'bde70bb6d2ff513409c634129601339c',
    sizes: {
      '300x250': { appnexusPlacementId: '26638269', openxUnit: '557911781' },
      '728x90': { appnexusPlacementId: '26638270', openxUnit: '557911782' },
    },
  },
  'wired.used.mdl': {
    pubmaticAdSlot: 'af7dd3bfabefa817c5f73fb77c5f10b3',
    sizes: {
      '300x250': { appnexusPlacementId: '26638280', openxUnit: '557911785' },
      '728x90': { appnexusPlacementId: '26638281', openxUnit: '557911787' },
    },
  },
};

export const isPrebidEligibleAd = adName =>
  Boolean(adName && (PREBID_AD_WHITELIST.includes(adName) || adName.includes('mrect')));

const getInventoryName = adUnitPath => {
  if (typeof adUnitPath !== 'string') {
    return '';
  }

  const [, , inventoryName = ''] = adUnitPath.split('/');
  return inventoryName;
};

export function getBidderParamsForSlot(adUnitPath, sizes) {
  const inventoryName = getInventoryName(adUnitPath);
  if (!inventoryName) {
    return [];
  }

  const inventoryConfig = PREBID_INVENTORY_CONFIG[inventoryName];
  if (!inventoryConfig) {
    return [];
  }
  const sizeConfigs = (sizes || [])
    .map(([width, height]) => inventoryConfig.sizes[`${width}x${height}`])
    .filter(Boolean);

  const cadentTagId = '181186';

  return [
    ...sizeConfigs.map(({ appnexusPlacementId }) => ({
      bidder: 'appnexus',
      params: { placementId: appnexusPlacementId },
    })),
    {
      bidder: 'pubmatic',
      params: {
        ...PUBMATIC_CONFIG,
        adSlot: inventoryConfig.pubmaticAdSlot,
      },
    },
    // Cadent Aperture MX bidder (requires custom Prebid bundle that includes the adapter).
    // If Cadent should be limited to certain inventories/sizes later, move this into PREBID_INVENTORY_CONFIG.
    {
      bidder: 'cadent_aperture_mx',
      params: { tagid: cadentTagId },
    },
    ...sizeConfigs.map(({ openxUnit }) => ({
      bidder: 'openx',
      params: { delDomain: OPENX_DEL_DOMAIN, unit: openxUnit },
    })),
  ];
}

export function getPrebidAdUnit({ adName, slotId, adUnitPath, sizes }) {
  const bannerSizes = Array.isArray(sizes) ? sizes.filter(size => Array.isArray(size) && size[0] > 2) : [];
  const bids = getBidderParamsForSlot(adUnitPath, bannerSizes);

  if (!isPrebidEligibleAd(adName) || !slotId || !bannerSizes.length || !bids.length) {
    return null;
  }

  return {
    code: slotId,
    mediaTypes: {
      banner: {
        sizes: bannerSizes,
      },
    },
    bids,
  };
}
